/**
 * @fileoverview A reusable tooltip component that appears on hover.
 */
import React from 'react';

interface TooltipProps {
  children: React.ReactElement;
  text: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string; // Allow passing extra classes to the wrapper
}

export const Tooltip: React.FC<TooltipProps> = ({ children, text, position = 'top', className }) => {
  const positionClasses = {
    top: 'bottom-full mb-2 left-1/2 -translate-x-1/2',
    bottom: 'top-full mt-2 left-1/2 -translate-x-1/2',
    left: 'right-full mr-2 top-1/2 -translate-y-1/2',
    right: 'left-full ml-2 top-1/2 -translate-y-1/2',
  };
  
  // A small triangle/arrow for the tooltip bubble.
  const arrowClasses = {
    top: 'absolute left-1/2 -translate-x-1/2 -bottom-1 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-t-4 border-t-slate-800 dark:border-t-gray-700',
    bottom: 'absolute left-1/2 -translate-x-1/2 -top-1 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-b-4 border-b-slate-800 dark:border-b-gray-700',
    left: 'absolute top-1/2 -translate-y-1/2 -right-1 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-l-4 border-l-slate-800 dark:border-l-gray-700',
    right: 'absolute top-1/2 -translate-y-1/2 -left-1 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-r-4 border-r-slate-800 dark:border-r-gray-700',
  };

  return (
    <div className={`relative flex items-center group ${className || ''}`}>
      {children}
      <div
        className={`absolute ${positionClasses[position]} max-w-xs whitespace-normal break-words text-left bg-slate-800 dark:bg-gray-700 text-white text-xs font-semibold px-3 py-1.5 rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-30`}
      >
        {text}
        <div className={arrowClasses[position]}></div>
      </div>
    </div>
  );
};
